import { useEffect } from "react";

import { useTabGuardContext } from "../context/TabGuardContext";

export const useTabGuard = (viewId: string, isDirty: boolean, saveHandler?: () => Promise<void>) => {
    const { registerTab, unregisterTab } = useTabGuardContext();

    useEffect(() => {
        registerTab(viewId, isDirty, saveHandler);

        return () => {
            unregisterTab(viewId);
        };
    }, [viewId, isDirty, saveHandler, registerTab, unregisterTab]);
};
